import React, { useState } from 'react';
import Pin from '../../../images/icons/pin.svg';
import Star from '../../../images/icons/star.svg';
import { makeStyles } from '@material-ui/core/styles';

const downloadIcon = (color) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path fill={color} fillRule="nonzero" d="M9 0v2h2V0H9zm0 4v8.586L5.707 9.293l-1.414 1.414L10 16.414l5.707-5.707-1.414-1.414L11 12.586V4H9zM0 15v3c0 1.093.907 2 2 2h16c1.093 0 2-.907 2-2v-3h-2v3H2v-3H0z" />
  </svg>
);

const headphonesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path fill="#044ADA" fillRule="nonzero" d="M11.868 0C5.601 0 .5 5.1.5 11.368v10.106A2.526 2.526 0 0 0 3.026 24h3.79v-8.842h-3.79v-3.79c0-4.875 3.967-8.842 8.842-8.842 4.876 0 8.843 3.967 8.843 8.842v3.79h-3.79V24h3.79a2.526 2.526 0 0 0 2.526-2.526V11.368C23.237 5.101 18.137 0 11.868 0z" />
  </svg>
);

const useStyle = makeStyles((theme) => ({
  bodyLarge: {
    border: '1px solid #c2c4d1',
    borderRadius: 4,
    width: '100%',
    backgroundColor: 'inherit',
    '&:hover': {
      backgroundColor: '#edf4ff',
      border: '1px solid #408bfc'
    },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    color: '#044ada',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1.57,
    padding: 24,
    cursor: 'pointer',
    height: '100%',
    '& p': {
      textAlign: 'center'
    }
  },
  bodySmall: {
    boxSizing: 'border-box',
    border: 'solid 1px #97c1ff',
    borderRadius: 4,
    width: '48px',
    maxWidth: 60,
    height: '48px',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#044ada;',
      border: 'solid 1px #044ada',
      color: '#fff'
    },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    color: '#044ada',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1.57,
    cursor: 'pointer'
  },
}));

const BotaoDownload = (props) => {

  const {
    children, onClickHandle, other, large, favorito, fixadoEmReuniao, circle, isAudio
  } = props;

  const classes = useStyle();

  const [cor, setCor] = useState('#044ada');
  const [arquivo, setArquivo] = useState('documento');


  return (
    <div onMouseEnter={() => setCor('#fff')}
      onMouseLeave={() => setCor('#044ada')}
      className={large ? classes.bodyLarge : classes.bodySmall}
      onClick={onClickHandle}
      style={circle ? { borderRadius: 50 } : isAudio ? { height: 149, width: 266 } : {}}>
      <div style={{ position: 'absolute', top: 5, right: 5 }}>
        {favorito && <img alt="" src={Star} />}
        {fixadoEmReuniao && <img alt="" src={Pin} />}
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {isAudio ? headphonesIcon() : downloadIcon(large ? '#044ada' : cor)}
      </div>
      {large ? children : ''}
    </div>
  );
}

export default BotaoDownload;
